const observer = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      const el = entry.target
      const bg = el.dataset.lazyBg
      if (bg) {
        el.style.backgroundImage = el.dataset.lazyBgGradient
          ? `${el.dataset.lazyBgGradient}, url('${bg}')`
          : `url('${bg}')`
        el.classList.add('lazy-bg-loaded')
      }
      observer.unobserve(el)
    })
  }, { rootMargin: '200px 0px' })
  : null

function applyImmediately(el, binding) {
  const bg = binding.value
  if (!bg) return
  if (binding.arg === 'gradient') {
    el.style.backgroundImage = binding.modifiers.overlay
      ? `linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)), url('${bg}')`
      : `url('${bg}')`
  } else {
    el.style.backgroundImage = `url('${bg}')`
  }
}

export default {
  mounted(el, binding) {
    const bg = binding.value
    if (!bg) return

    if (binding.modifiers.eager || !observer) {
      applyImmediately(el, binding)
      return
    }

    el.dataset.lazyBg = bg
    if (binding.modifiers.overlay) {
      el.dataset.lazyBgGradient = 'linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25))'
    }
    observer.observe(el)
  },
  unmounted(el) {
    if (observer) observer.unobserve(el)
  }
}
